module.exports = "/images/marking-icon-camera_new.svg?6f65d2601f19bb1c0a4c77423cfc71bd";